export default __webpack_public_path__ + "static/media/rentImage-2.bc09e56a.jpg";